import styled from '@emotion/styled';

export const LabelContainer = styled.div`
  display: flex;
`;

export const LabelTag = styled.div`
  color: #ff7b0c;
  background: rgba(255, 134, 32, 0.14);
  border-radius: 4px;
  font-size: 9px;
  text-align: center;
  padding: 5px 8px;
  margin-left: 8px;
  font-weight: 800;
  align-self: self-end;
  letter-spacing: 0.2px;
  line-height: 11px;
`;
